// Learner App does not support translation (see /learnerApp/src/App.tsx)
/* eslint-disable i18next/no-literal-string */
import { Box, OsStack, Typography } from "@outschool/backpack";
import { useFeatureFlag } from "@outschool/ui-components-shared";
import React, { useState } from "react";

import HeroLayoutWithTabs from "../../layout/HeroLayoutWithTabs/HeroLayoutWithTabs";
import { learnerRoutes } from "../../lib/Routes";
import { NotFoundPage } from "../NotFoundPage";
import { TopicFilter } from "./consts";
import MixTopicCard from "./MixTopicCard";
import MixTopicModal, { ModalMixTopic } from "./MixTopicModal";
import TopicFilterButton from "./TopicFilterButton";
import useTopicsForFilter from "./useTopicsForFilter";

export default function LearnerDiscovery() {
  const isMixUpEnabled = useFeatureFlag("nav-pod-mix-up-machine");

  const [selectedTopics, setSelectedTopics] = useState<string[]>([]);
  const [openModalTopic, setOpenModalTopic] = useState<ModalMixTopic | null>(
    null,
  );
  const [selectedTopicFilter, setSelectedTopicFilter] = useState<TopicFilter>(
    TopicFilter.All,
  );

  const { data: topicsToShow } = useTopicsForFilter(selectedTopicFilter);

  const onModalClose = () => setOpenModalTopic(null);
  const onModalSave = () => {
    // If filtered to Default, reset to All so that newly saved mix shows
    if (selectedTopicFilter === TopicFilter.DefaultTopics) {
      setSelectedTopicFilter(TopicFilter.All);
    }
  };

  // TODO: trigger modal on async response from generate endpoint

  if (!isMixUpEnabled) {
    return <NotFoundPage />;
  }

  return (
    <HeroLayoutWithTabs currentPath={learnerRoutes.discoveryPath()}>
      <OsStack direction="column" spacing={6}>
        <Typography variant="h2">{"The Mix-Up Machine"}</Typography>
        <Typography variant="body1" sx={{ color: "grey.600" }}>
          {"Select 2 topics and mix them to explore your interests."}
        </Typography>
        <OsStack direction="row" spacing={2}>
          {Object.values(TopicFilter).map(filter => (
            <TopicFilterButton
              key={filter}
              filter={filter}
              selectedFilter={selectedTopicFilter}
              onFilterChange={setSelectedTopicFilter}
            />
          ))}
        </OsStack>
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: "20px",
            marginY: "2em",
          }}
        >
          {topicsToShow.map(
            ({ uid, title, attachmentUrl, description, isDefault }) => (
              <MixTopicCard
                key={uid}
                title={title}
                imageUrl={attachmentUrl}
                isDefault={isDefault}
                isSelected={selectedTopics.includes(uid)}
                onCardClick={() => {
                  if (selectedTopics.includes(uid)) {
                    setSelectedTopics(selectedTopics.filter(t => t !== uid));
                  } else if (selectedTopics.length < 2) {
                    setSelectedTopics([...selectedTopics, uid]);
                  } else {
                    return;
                  }
                }}
                onButtonClick={() => {
                  setOpenModalTopic({
                    uid,
                    title,
                    description,
                    imageUrl: attachmentUrl,
                    isDefault,
                  });
                }}
              />
            ),
          )}
        </Box>
        <MixTopicModal
          topic={openModalTopic}
          onClose={onModalClose}
          onSave={onModalSave}
        />
      </OsStack>
    </HeroLayoutWithTabs>
  );
}
